import { render, staticRenderFns } from "./CabecerasHttp.vue?vue&type=template&id=5c30591f&"
import script from "./CabecerasHttp.vue?vue&type=script&lang=ts&"
export * from "./CabecerasHttp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5c30591f', component.options)
    } else {
      api.reload('5c30591f', component.options)
    }
    module.hot.accept("./CabecerasHttp.vue?vue&type=template&id=5c30591f&", function () {
      api.rerender('5c30591f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/Step/CabecerasHttp.vue"
export default component.exports